// import React, { useEffect, useState } from "react";
// import { Tooltip } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { Link, useNavigate } from "react-router-dom";
// import PaginationComponent from "../../Components/PaginationComponent";
// import patientService from "../../Services/patientService";
// import PatientDetails from '../Patients/PatientDetails';
// import toast from 'react-hot-toast';

// const Patients = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [patients, setPatients] = useState([]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const getPatients = async () => {
//       try {
//         setLoading(true);
//         const response = await patientService.fetchAllPatients();
//         console.log(response);
//         setPatients(response.patients);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error('Error fetching Patients');
//       }
//     };
//     getPatients();
//   }, []);

//   useEffect(() => {
//     const filteredResult = patients?.filter(
//       (item) =>
//         item?.contact_number?.toLowerCase().includes(searchData.toLowerCase()) ||
//       item?.CNIC?.toLowerCase().includes(searchData.toLowerCase())
//     ) || [];
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, patients]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   // Utility function to format date
// const formatDate = (dateString) => {
//   if (!dateString) return ''; // Handle null or undefined
//   const options = { year: 'numeric', month: 'short', day: 'numeric' };
//   return new Date(dateString).toLocaleDateString('en-US', options);
// };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[19px] text-gray-700 font-[700]">Patients Table</h1>
//         <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">{filteredData?.length || 0} records found</h1>

//         <div className="flex mt-8 flex-row-reverse justify-between px-[3%]">
//           {/* <Link to='AddEdit'>
//             <button className="bg-[#232233] h-[2rem] px-4 rounded-md text-white font-[600] text-[14px]">
//               + Enter Patient
//             </button>
//           </Link> */}
//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search By Phone or CNIC..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 rounded-md border-gray-800 bg-white focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-700 ml-2" />
//           </div>
//         </div>

//         <div className="mx-[3%]">
//           <table className="w-[100%] rounded-xl overflow-hidden">
//             <thead>
//               <tr className="bg-gray-700 capitalize text-xs text-left leading-normal text-white">
//               <th className="py-4 w-[10%] pl-4">Patient NO.</th>
//               <th className="py-4 w-[15%] pl-4">Check up Date</th>
//               <th className="py-4 w-[20%] pl-4">Patient Name</th>
//               <th className="py-4 w-[10%]">Contact Number</th>
//               <th className="py-4 w-[10%] text-center">CNIC</th>
//               <th className="py-4 w-[20%] text-center">Address</th>

//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData?.map((patient) => (
//                 <tr key={patient?.patient_id} className="bg-white text-xs font-light border-t-[1px] border-gray-200">
//                   <td className="py-4 w-[10%] text-left pl-4 font-bold">
//                     {patient?.patient_id}.
//                   </td>
//                   <td className="w-[15%] text-left pl-4">
//                     {formatDate(patient?.checkup_date)}
//                   </td>
//                   <td className=" w-[20%] text-left pl-4 font-bold">
//                     {patient?.full_name}
//                   </td>
//                   <td className="w-[10%] text-left">
//                     {patient?.contact_number}
//                   </td>
//                   <td className="w-[10%] text-center">
//                     {patient?.CNIC}
//                   </td>
//                   <td className="w-[20%] text-center">
//                     {patient?.address}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <PaginationComponent
//           filteredData={filteredData}
//           setPaginatedData={setPaginatedData}
//           itemsPerPage={itemsPerPage}
//           currentPage={currentPage}
//           setCurrentPage={setCurrentPage}
//         />
//       </div>
//     </div>
//   );
// };

// export default Patients;

import React, { useEffect, useState } from "react";
import patientService from "../../Services/patientService";
import toast from "react-hot-toast";

const formatDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const Patients = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getPatients = async () => {
      try {
        setLoading(true);
        const response = await patientService.fetchAllPatients();
        setPatients(response.patients);
      } catch (error) {
        toast.error("Error fetching Patients");
      } finally {
        setLoading(false);
      }
    };
    getPatients();
  }, []);

  useEffect(() => {
    const result =
      patients?.filter(
        (item) =>
          item?.contact_number
            ?.toLowerCase()
            .includes(searchData.toLowerCase()) ||
          item?.CNIC?.toLowerCase().includes(searchData.toLowerCase()),
      ) || [];
    setFilteredData(result);
  }, [searchData, patients]);

  const colWidths = ["80px", "130px", "170px", "130px", "150px", "180px"];
  const ColGroup = () => (
    <colgroup>
      {colWidths.map((w, i) => (
        <col key={i} style={{ width: w, minWidth: w }} />
      ))}
    </colgroup>
  );

  return (
    <div className="p-3 sm:p-4 font-sans">
      {/* ── Header ── */}
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
          <p className="text-xs font-medium tracking-widest uppercase text-gray-500">
            Patients
          </p>
          <p className="text-xs text-gray-400 mt-0.5">
            {filteredData.length || 0} records found
          </p>
        </div>
      </div>

      {/* ── Search ── */}
      <div className="relative mb-4">
        <svg
          className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
          />
        </svg>
        <input
          type="search"
          placeholder="Search by phone or CNIC..."
          value={searchData}
          onChange={(e) => setSearchData(e.target.value)}
          className="w-full sm:w-72 pl-9 pr-4 py-3 text-xs border border-gray-200 rounded-lg bg-white text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-100"
        />
      </div>

      {/* ══ MOBILE CARDS ══ */}
      <div className="block sm:hidden space-y-2">
        {loading ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            Loading...
          </div>
        ) : filteredData.length === 0 ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            No patients found
          </div>
        ) : (
          filteredData.map((patient) => (
            <div
              key={patient?.patient_id}
              className="border border-gray-200 rounded-xl bg-white px-3 py-3"
            >
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-[11px] font-semibold text-gray-600 uppercase flex-shrink-0">
                  {patient?.full_name?.charAt(0) || "P"}
                </div>
                <div>
                  <p className="text-[12px] font-semibold text-gray-800">
                    {patient?.full_name}
                  </p>
                  <p className="text-[10px] text-gray-400">
                    #{patient?.patient_id}
                  </p>
                </div>
              </div>
              <div className="divide-y divide-gray-100">
                {[
                  { label: "Date", value: formatDate(patient?.checkup_date) },
                  { label: "Phone", value: patient?.contact_number },
                  { label: "CNIC", value: patient?.CNIC },
                  { label: "Address", value: patient?.address },
                ].map(({ label, value }) =>
                  value ? (
                    <div key={label} className="flex justify-between py-1.5">
                      <span className="text-[11px] text-gray-400 w-16">
                        {label}
                      </span>
                      <span className="text-[11px] text-gray-700 text-right flex-1 ml-2 truncate">
                        {value}
                      </span>
                    </div>
                  ) : null,
                )}
              </div>
            </div>
          ))
        )}
      </div>

      {/* ══ DESKTOP TABLE ══ */}
      <div className="hidden sm:block border rounded-xl overflow-hidden">
        <div className="overflow-y-auto" style={{ maxHeight: "520px" }}>
          <table
            className="w-full text-sm"
            style={{
              tableLayout: "fixed",
              borderCollapse: "separate",
              borderSpacing: 0,
            }}
          >
            <ColGroup />
            <thead>
              <tr>
                {[
                  "Patient No.",
                  "Checkup Date",
                  "Patient Name",
                  "Contact Number",
                  "CNIC",
                  "Address",
                ].map((label, i) => (
                  <th
                    key={label}
                    className={`sticky top-0 z-20 bg-[#215187] text-left px-4 py-2.5 text-[11px] text-gray-100 uppercase font-medium ${
                      i < 5 ? "border-r border-white/10" : ""
                    }`}
                  >
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan={6}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    Loading...
                  </td>
                </tr>
              ) : filteredData.length === 0 ? (
                <tr>
                  <td
                    colSpan={6}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    No patients found
                  </td>
                </tr>
              ) : (
                filteredData.map((patient, index) => (
                  <tr
                    key={patient?.patient_id}
                    className={`border-b border-gray-100 hover:bg-green-50 transition-colors ${
                      index % 2 ? "bg-gray-50" : "bg-white"
                    }`}
                  >
                    <td className="px-4 py-2.5 text-[12px] font-semibold text-gray-500 border-r border-gray-100">
                      {patient?.patient_id}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      {formatDate(patient?.checkup_date)}
                    </td>
                    <td className="px-4 py-2.5 border-r border-gray-100">
                      <div className="flex items-center gap-2">
                        {/* <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center text-[10px] font-semibold text-gray-600 uppercase flex-shrink-0">
                          {patient?.full_name?.charAt(0) || "P"}
                        </div> */}
                        <span className="text-[12px] font-medium text-gray-800 truncate">
                          {patient?.full_name}
                        </span>
                      </div>
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      {patient?.contact_number}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      {patient?.CNIC}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 truncate">
                      {patient?.address}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan={6}
                  className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] font-medium text-gray-100 border-t border-white/10"
                >
                  {filteredData?.length || 0} total records
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Patients;
